import Vue from 'vue';

const scrollEventBus = new Vue();

export { scrollEventBus };
